// extracted by mini-css-extract-plugin
export var standaloneTable = "_ek-0";
export var standaloneTableWithBodyFill = "_ek-1";
export var withExtraHeader = "_ek-2";